import type React from 'react';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { ReactComponent as ProfileIcon } from 'assets/images/profile.svg';
import { ReactComponent as SearchIcon } from 'assets/images/search.svg';
import UserProfileModal from 'components/header/UserProfileModal';
import { useLatestOrders } from 'hooks/useLatestOrders';
import { useAppSelector } from 'store/customHooks';

const DefaultHeaderContent: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const branchData = useAppSelector((state) => state.auth.branch);
  const tableInfo = useAppSelector((state) => state.tableStatusAndOrder.tableInfo);
  const customerDetails = useAppSelector((state) => state.tableStatusAndOrder?.customerDetails);
  const orderDetails = useAppSelector(
    (state) => state?.tableStatusAndOrder?.orderDetails?.orderGroups,
  );
  const checkIn = sessionStorage.getItem('CheckIn');
  const branchSessionStorageData = JSON.parse(sessionStorage.getItem('Branch') || '{}');

  const { defaultHeaderLogo, altName } = useAppSelector((state) => state.header);

  const [showCustomerDetails, setShowCustomerDetails] = useState(false);
  const { latestFoodTime, latestDrinkTime } = useLatestOrders(orderDetails);

  useEffect(() => {
    if (!checkIn) {
      window.location.href = '/';
    }
  }, [checkIn]);

  useEffect(() => {
    setShowCustomerDetails(false);
  }, [location]);

  return (
    <div className='defaultHeader'>
      <div className='flex justify-between relative items-center headerContainer'>
        <div className='flex'>
          <img
            alt={altName || ''}
            src={defaultHeaderLogo}
            className='mx-2 sm:mx-[20px]'
            onClick={() => navigate('/home')}
          />
          <div>
            <div className='branchInfo'>
              {latestFoodTime || latestDrinkTime ? (
                <div className='pl-1 flex items-center text-[12px] sm:text-[14px] whitespace-nowrap'>
                  <span>Last Order:&nbsp;</span>
                  <div className='flex gap-1 sm:gap-2'>
                    {latestFoodTime && (
                      <div className='flex items-center'>
                        Food{' '}
                        <span className='inactiveTabText font-bold text-[11px] sm:text-[12px] ml-1'>
                          {latestFoodTime}
                        </span>
                      </div>
                    )}
                    {latestDrinkTime && (
                      <div className='flex items-center'>
                        Drink{' '}
                        <span className='inactiveTabText font-bold text-[11px] sm:text-[12px] ml-1'>
                          {latestDrinkTime}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                <div className='text-[12px] sm:text-[14px]'>
                  <span>{branchData?.displayName || branchSessionStorageData?.displayName}:</span>
                  <span className='ml-[5px]'>TABLE {tableInfo?.tableNames?.join(', ')}</span>
                </div>
              )}
              <div className='flex justify-start items-center'>
                {(latestFoodTime || latestDrinkTime) && (
                  <>
                    <span className='ml-[5px] text-[12px] sm:text-[14px]'>
                      TABLE {tableInfo?.tableNames?.join(', ')}
                    </span>{' '}
                    &nbsp;
                  </>
                )}
                <button className='pinInfo p-[2px]'>
                  <span>PIN </span>
                  <span>{tableInfo?.tableCode ?? customerDetails?.tableCode}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className='flex items-center gap-2 sm:gap-6 pr-2 sm:pr-4'>
          <div
            className='flex flex-col sm:flex-row items-center cursor-pointer'
            onClick={() => navigate('/search')}
          >
            <SearchIcon className='headerIconColor w-6 h-6 sm:w-6 sm:h-6 sm:mr-2' />
            <span className='headerIconColor font-medium text-[11px] sm:text-sm'>Search</span>
          </div>
          <div
            className='flex flex-col sm:flex-row items-center cursor-pointer'
            onClick={() => setShowCustomerDetails(!showCustomerDetails)}
          >
            <ProfileIcon
              className={`headerIconColor w-6 h-6 sm:w-6 sm:h-6 sm:mr-2 ${
                showCustomerDetails && 'z-[9999]'
              }`}
            />
            <span className='headerIconColor font-medium text-[11px] sm:text-sm'>Account</span>
          </div>
        </div>
      </div>
      {showCustomerDetails && (
        <UserProfileModal handleClose={() => setShowCustomerDetails(false)} />
      )}
    </div>
  );
};

export default DefaultHeaderContent;
